import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { saveUserPreferences } from "./utils/core-utils/preferenceUtils";

// Global driver JS function calling across component
export const globalDriverJsFunction = (driverData: any) => {
  const {
    type,
    userPreferences,
    setUserPreferences,
    setUpdatedUserPrefData,
    updatedUserPrefData,
    steps,
  } = driverData;

  console.log("userPreferences test", userPreferences);
  const driverObj = driver({
    onDestroyed: () => {
      const newUserPref = Object.assign(
        {},
        JSON.parse(userPreferences.app_tour),
      );
      newUserPref[type] = true;
      userPreferences.app_tour = JSON.stringify(newUserPref);
      setUserPreferences(userPreferences);
      setUpdatedUserPrefData(!updatedUserPrefData);
      console.log("driver userPreferences", userPreferences);
      saveUserPreferences(userPreferences);
      driverObj.destroy();
    },
    showProgress: true,
    allowClose: true,
    steps: steps,
    popoverClass: "driverjs-theme",
    showButtons: ["next", "previous", "close"],
  });
  driverObj.drive();
};
